import { groupBySection, type PlanChangeRow } from './change-format'
import { useTranslations } from "next-intl"
import { usePlanPresentation } from "./use-plan-presentation"




export function ChangeList({ rows }: { rows: PlanChangeRow[] }) {
  const presentation = usePlanPresentation()


  const tUi = useTranslations("Billing.BillingPlanEditorChangeList")

  return (
    <div className="space-y-4">
      {groupBySection(rows, presentation).map(group => (
        <section key={group.id} aria-label={tUi("value0Changes", { value0: String(group.title) })} className="space-y-2">
          <h3 className="text-sm font-semibold">{group.title}</h3>
          <ul className="space-y-2">
            {group.rows.map(row => (
              <li key={row.field} className="min-w-0 text-sm">
                <p className="font-medium">{row.label}</p>
                <p className="break-words text-muted-foreground">
                  <span>{row.from}</span><span aria-hidden="true"> → </span><span className="sr-only"> <span key={tUi("changesTo")}>{tUi("changesTo")}</span></span><span className="text-foreground">{row.to}</span>
                </p>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
